import {apiSaveSettings, apiLoadSettings} from './baseApi';

export const apiSaveCommonSettings = (data, callback) => {
  apiSaveSettings(data, callback, 'common')
}

export const apiLoadCommonSettings = (callback) => {
  apiLoadSettings(callback, 'common')
}